import type { AnalysisIntensity } from '../types/Collateral';

export const formatCurrency = (value: number): string =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);

export const formatPercentage = (value: number): string => `${value.toFixed(2)}%`;

export const formatDate = (value: string): string => {
    if (!value) return '';
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) return `${match[3]}/${match[2]}/${match[1]}`;
    return value;
};

export { formatTaxId as formatCpfCnpj } from './taxIdUtils';

export const calculateIntensity = (docs: { xml: boolean; nf: boolean; canhoto: boolean; duplicata: boolean }, titleCount: number): { score: number; level: AnalysisIntensity } => {
    let docScore = 0;
    if (docs.xml) docScore += 1;
    if (docs.nf) docScore += 2;
    if (docs.canhoto) docScore += 4;
    if (docs.duplicata) docScore += 5;

    let titleScore = 0;
    if (titleCount <= 50) titleScore = 1;
    else if (titleCount <= 100) titleScore = 2;
    else if (titleCount <= 150) titleScore = 4;
    else titleScore = 5;

    const total = docScore + titleScore;
    let level: AnalysisIntensity = '';
    if (total <= 4) level = 'BAIXA';
    else if (total <= 8) level = 'MÉDIA';
    else if (total <= 13) level = 'ALTA';
    else level = 'CAÓTICA';

    return { score: total, level };
};

export const getIntensityColor = (level: AnalysisIntensity): string => {
    const map: Record<string, string> = {
        BAIXA: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
        MEDIA: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
        'MÉDIA': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
        ALTA: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
        CAOTICA: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
        'CAÓTICA': 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
    };
    return map[level] || 'bg-gray-100 text-gray-800';
};



